import { Box } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";

export interface IFooterCellRendererParams extends ICellRendererParams {
    aggregate: string;
}

export function FooterCellRenderer({
    value,
    aggregate
}: IFooterCellRendererParams) {

    const text = value && value !== '' ?
                        aggregate === 'sum' ? 
                            `${value.toLocaleString("en-US", { minimumFractionDigits: 2 })} (Sum)` :
                        aggregate === 'avg' ? 
                            `${value.toLocaleString("en-US", { minimumFractionDigits: 2 })} (Avg)` :
                        aggregate === 'count' ? 
                            `Count: ${value.toLocaleString("en-US")}` : 
                        `${value.toLocaleString("en-US")}` : 
                    '';
    return (
            <Box component='span' sx={{fontWeight: 700}}>
                {text}
            </Box>
    )
}

